import { render } from "./NotificationMenu.vue?vue&type=template&id=593b8914&ts=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__